// src/app/test.component.ts
import { Component } from '@angular/core';

@Component({
  selector: 'app-test',
  template: `
    <div style="padding: 20px; background-color: #ff9; color: #333;">
      <h2>Test Component</h2>
      <p>This is a direct test component to verify routing.</p>
    </div>
  `
})
export class TestComponent {
  constructor() {
    console.log('TestComponent constructed');
  }

  ngOnInit() {
    console.log('TestComponent initialized');
  }
}